





import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Tab, { TabRoutes } from '@/components/poultry/Tab.vue';
import { Role } from '@/utils/constants';
import { ProfileStores } from '@/store/swine/profile/index';

@Component({
  components: {
    Tab
  }
})
export default class ClientDetailsTab extends Vue {
  profileStore = ProfileStores.profile;

  // Only admins and regionals assign auditors to clients.
  get tabRoutes(): TabRoutes[] {
    const role = this.profileStore.userProfile ? this.profileStore.userProfile.role : '';
    const routes: TabRoutes[] = [{ text: 'Farms', name: 'client.details.farms' }];
    if (role === Role.Admin || role === Role.Regional) {
      routes.push({ text: 'Auditors', name: 'client.details.auditors' });
    }
    return routes;
  }
}
